export default __webpack_public_path__ + "static/media/portfolio-121.f49d94d8.jpg";